<template>
  <div>
    <div class="timeline__card-body d-flex align-items-center">
      <div
        v-for="(el, idx) in tripStates"
        :key="idx"
        class="d-flex flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        style="width:150px;gap:5px;"
      >
        <trip-status-badge
          :status="el.state"
        />
        <small>Action By: {{ el.metadata.action_by }}</small>
        <small class="text-muted">At: {{ el.created_at | formatDate }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import {
  inject, computed,
} from '@vue/composition-api'
import { tripStatusFormatter, tripColorGenerator, tripIconGenerator } from '../../hooks/tripStatusUtils'
import tripStatusBadge from '../TripStatusBadge.vue'

export default {
  components: {
    tripStatusBadge,
  },
  setup() {
    const trip = inject('trip')
    const tripStates = computed(() => trip?.value?.states || [])
    return {
      tripStates,
      tripStatusFormatter,
      tripColorGenerator,
      tripIconGenerator,
    }
  },
}
</script>
<style scoped>
.timeline__card-body {
gap:15px;
  flex-wrap: wrap
}
</style>
